exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-pagination.organize{margin:20px auto 0;text-align:center;position:relative}.organize .swiper-pagination-bullet-active:focus,.organize .swiper-pagination-bullet:active{outline:0}.organize .swiper-pagination-bullet-active{background:#a039ff!important}.organize .swiper-pagination-bullet{width:10px;height:10px;margin-right:25px;background:#e0bfff;opacity:.5}.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 10px}.swiper-button-prev{background-image:url(\"/img/home-v2/arrow-left.svg\")}.swiper-button-next{background-image:url(\"/img/home-v2/arrow-right.svg\")}.swiper-button-next:active,.swiper-button-next:focus,.swiper-button-prev:active,.swiper-button-prev:focus{outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c7dc1f6","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/js/frontend/components/SingleCategoryTemplates.vue
// module id = x//M
// module chunks = 3